package DataBase

import Structs.User

 object DB : UINKDBInterface() {
}